#import "../fragments/peep-engagement-stats.graphql"

query GetPeepEngagementStats($id: ID!) {
    peep(id: $id) {
        ...PeepEngagementStats
    }
}
